import React from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Tag } from 'primereact/tag';
import { Divider } from 'primereact/divider';
import { format } from 'date-fns';
import { CourseWithGrades } from '../../../types';
import { LectureDetailsStudent } from '../../../../../../api/types/students/lectures/student-lectures';

interface LecturesTabProps {
  selectedCourse: CourseWithGrades;
}

export const LecturesTab: React.FC<LecturesTabProps> = ({ selectedCourse }) => {
  const attendanceStatusTemplate = (lecture: LectureDetailsStudent) => {
    if (!lecture.attendanceType) {
      return <Tag value="לא הוזנו נתוני נוכחות" severity="secondary" />;
    }

    switch (lecture.attendanceType) {
      case 'attended':
        return (
          <Tag
            style={{ width: '130px' }}
            value="נכח"
            severity="success"
            icon="pi pi-check"
          />
        );
      case 'late':
        return (
          <Tag
            style={{ width: '130px' }}
            value="איחור"
            severity="warning"
            icon="pi pi-clock"
          />
        );
      case 'missed':
        return (
          <Tag
            style={{ width: '130px' }}
            value="חיסור"
            severity="danger"
            icon="pi pi-times"
          />
        );
      default:
        return (
          <Tag
            style={{ width: '120px' }}
            value="לא ידוע"
            severity="secondary"
          />
        );
    }
  };

  const lectureTypeTemplate = (lecture: LectureDetailsStudent) => {
    if (!lecture.scheduleType) return '-';
    return lecture.scheduleType === 'lecture' ? 'הרצאה' : 'בחינה';
  };

  const formatDateTime = (date: Date | string | undefined) => {
    if (!date) return '';
    return format(new Date(date), 'dd/MM/yyyy HH:mm');
  };

  const formatTime = (date: Date | string | undefined) => {
    if (!date) return '';
    return format(new Date(date), 'HH:mm');
  };

  return (
    <div>
      <div className="course-summary">
        <div className="course-summary-item">
          <span className="summary-label">סך הרצאות:</span>
          <span>{selectedCourse.lectures?.length || 0}</span>
        </div>
        <div className="course-summary-item">
          <span className="summary-label">נוכחות:</span>
          <span>{selectedCourse.attendanceCount} הרצאות</span>
        </div>
        <div className="course-summary-item">
          <span className="summary-label">אחוז נוכחות:</span>
          <span>{selectedCourse.attendancePercentage}%</span>
        </div>
      </div>

      <Divider />

      <div className="dialog-lectures-attendance">
        <h3>פירוט נוכחות בהרצאות</h3>
        <DataTable
          value={selectedCourse.lectures || []}
          className="lectures-attendance-table"
          responsiveLayout="stack"
          breakpoint="768px"
          showGridlines
          dir="rtl"
          emptyMessage="לא נמצאו הרצאות"
        >
          <Column
            field="date"
            header="תאריך"
            body={(rowData) => formatDateTime(rowData.startTime)}
            sortable
          />
          <Column
            field="startTime"
            header="שעת התחלה"
            body={(rowData) => formatTime(rowData.startTime)}
            sortable
          />
          <Column
            field="endTime"
            header="שעת סיום"
            body={(rowData) => formatTime(rowData.endTime)}
            sortable
          />
          <Column
            field="scheduleType"
            header="סוג מפגש"
            body={(rowData) => lectureTypeTemplate(rowData)}
            sortable
          />
          <Column
            field="className"
            header="כיתה"
            body={(rowData) => rowData.className || '-'}
            sortable
          />
          <Column
            field="attendanceType"
            header="נוכחות"
            body={(rowData) => attendanceStatusTemplate(rowData)}
            sortable
          />
        </DataTable>
      </div>
    </div>
  );
};
